/**
 * @desc 根据平台订单号查询是否有退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RejectBillPageDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asRefundOrder/page`, {
      method: "DELETE",

      data: body,
      ...options,
    }),
  );
}
